import {
  FundraiseActivityDocument,
  useDeleteNoteMutation as useBaseMutation
} from 'generated/graphql';
import { useLoading } from 'modules';



export function useDeleteNoteMutation() {
  const [deleteNote, deleteNoteTuple] = __useDeleteNoteMutation();
  const loading = useLoading([deleteNoteTuple]);

  return {
    loading,
    mutation: {
      deleteNote
    }
  };
}



function __useDeleteNoteMutation() {
  const [fnMutate, tuple] = useBaseMutation({
    awaitRefetchQueries: true,
    refetchQueries: [
      FundraiseActivityDocument,
      'FundraiseActivity'
    ]
  });

  async function fnWrappedMutate(id: string) {
    await fnMutate({
      variables: {
        id
      }
    });
  }

  return [fnWrappedMutate, tuple] as const;
}
